import { type PlatformApi } from '../controller/platform-api';

export const getHomepage = async (platformApi: PlatformApi) => {
  const { pages } = await platformApi.site.getSiteStructure();
  return pages.find((page) => page.isHomePage);
};
